import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const DepotContext = createContext(null);

export function DepotProvider({ children }) {
  const { user, isAdmin } = useAuth();
  const [depots, setDepots] = useState([]);
  const [selected, setSelectedState] = useState(() => localStorage.getItem("depot_scope") || "all");

  const reload = useCallback(async () => {
    const { data } = await api.get("/depots");
    setDepots(data);
  }, []);

  useEffect(() => {
    if (user) {
      reload().catch(() => {});
    }
  }, [user, reload]);

  const setSelected = useCallback((v) => {
    localStorage.setItem("depot_scope", v);
    setSelectedState(v);
  }, []);

  const scopeId = isAdmin ? selected : user?.depot_id;
  const depotParam = !scopeId || scopeId === "all" ? undefined : scopeId;
  const depotName = useCallback((id) => depots.find((d) => d.id === id)?.name || "—", [depots]);
  const scopeLabel = depotParam ? depotName(depotParam) : "All Depots";
  const value = useMemo(() => ({ depots, reload, selected, setSelected, depotParam, depotName, scopeLabel }),
    [depots, reload, selected, setSelected, depotParam, depotName, scopeLabel]);

  return (
    <DepotContext.Provider value={value}>
      {children}
    </DepotContext.Provider>
  );
}

export const useDepot = () => useContext(DepotContext);
